<template>
  <v-layout
    align-center
    justify-center
  >
    <v-flex
      xs12
      sm12
      md11
      lg8
    >
      <app-loader
        title="Загрузка данных Нового запроса"
        :loading="!pageLoaded"
      />

      <v-layout
        v-show="pageLoaded"
        align-center
      >
        <v-flex
          xs1
          class="text-xs-center"
        >
          <v-btn
            flat
            large
            icon
            @click="stepper = prevStep"
          >
            <v-icon
              x-large
              color="primary"
            >
              keyboard_arrow_left
            </v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs10>
          <v-layout>
            <h1 class="headline mb-2">
              Новый запрос
            </h1>
          </v-layout>
          <v-card class="elevation-0">
            <v-card-text class="pa-0">
              <v-form
                v-if="entity"
                v-model="isValid"
                @input="handleEntityChange"
              >
                <v-stepper
                  v-model="stepper"
                  class="pa-0 elevation-0"
                >
                  <v-stepper-header class="mb-2">
                    <v-stepper-step
                      :complete="stepper > 1"
                      step="1"
                      editable
                      class="px-2 py-0"
                      @click="stepper = 1"
                    >
                      {{ stepTitles[0] }}
                    </v-stepper-step>

                    <v-divider class="ma-0" />

                    <v-stepper-step
                      :complete="stepper > 2"
                      step="2"
                      editable
                      class="px-2 py-0"
                      @click="stepper = 2"
                    >
                      {{ stepTitles[1] }}
                    </v-stepper-step>

                    <v-divider class="ma-0" />

                    <v-stepper-step
                      :complete="stepper > 3"
                      step="3"
                      editable
                      class="px-2 py-0"
                      @click="stepper = 3"
                    >
                      {{ stepTitles[2] }}
                    </v-stepper-step>

                    <v-divider class="ma-0" />

                    <v-stepper-step
                      :complete="stepper > 4"
                      step="4"
                      editable
                      class="px-2 py-0"
                      @click="stepper = 4"
                    >
                      {{ stepTitles[3] }}
                    </v-stepper-step>

                    <v-divider class="ma-0" />

                    <v-stepper-step
                      step="5"
                      editable
                      class="px-2 py-0"
                      @click="stepper = 5"
                    >
                      {{ stepTitles[4] }}
                    </v-stepper-step>
                  </v-stepper-header>

                  <v-stepper-items
                    class="mx-1 mt-3 mb-2"
                    :style="{
                      height: `${blockHeight + 'px'}`,
                      'overflow-y': 'auto'
                    }"
                  >
                    <v-stepper-content
                      step="1"
                      class="pa-0"
                    >
                      <h2 class="mx-2 stepper-title">
                        Основные данные по Запросу
                      </h2>
                      <v-layout column>
                        <v-flex>
                          <app-reference
                            v-model="entity.Client"
                            :outline="true"
                            :height-field="44"
                            class="ma-2"
                            label="Клиент*"
                            :rules="[v => !!v || '']"
                            :disabled="isClient"
                            resource="clients"
                            component-name="Client"
                            @input="clientChanged"
                          />
                        </v-flex>
                        <v-flex>
                          <ManagerSelect
                            v-model="entity.Employee"
                            label="Менеджер*"
                            :rules="[v => !!v || '']"
                            :disabled="!entity.Client"
                            class="mx-2 my-2"
                            @input="employeeChanged"
                          />
                        </v-flex>
                      </v-layout>
                    </v-stepper-content>

                    <v-stepper-content
                      step="2"
                      class="pa-0"
                    >
                      <h2 class="mx-2 stepper-title">
                        Первоначальное местонахождение груза
                      </h2>
                      <v-layout column>
                        <v-layout>
                          <v-flex>
                            <app-reference
                              v-model="entity.SendingCountry"
                              :outline="true"
                              :height-field="44"
                              class="ma-2"
                              label="Страна отправления*"
                              :rules="[v => !!v || '']"
                              resource="countries"
                              component-name="Country"
                              @input="sendingCountryChanged"
                            />
                          </v-flex>
                          <v-flex>
                            <app-reference
                              v-model="entity.Manufacturer"
                              :outline="true"
                              :height-field="44"
                              class="ma-2"
                              label="Производитель*"
                              :rules="[v => !!v || '']"
                              resource="manufacturers"
                              component-name="Manufacturer"
                              :without-parent-lock="true"
                            />
                          </v-flex>
                        </v-layout>
                        <v-layout>
                          <v-flex xs6>
                            <app-tiny-reference
                              ref="client-alias"
                              v-model="entity.ClientAlias"
                              :outline="true"
                              class="ma-2"
                              label="Клиент по документам"
                              resource="clients/aliases"
                              parent-filter="clientId"
                              :parent-id="entity.Client ? entity.Client.id : 0"
                              :without-length-lock="true"
                              :height-field="44"
                              @input="handleEntityChange"
                            >
                              <template v-slot:append-content="slotProps">
                                <v-layout align-end>
                                  <v-text-field
                                    v-model="newClientAlias"
                                    outline
                                    class="px-1 pt-0 mt-0 text-field-size"
                                    placeholder="Добавить название"
                                    hide-details
                                    height="44"
                                  />
                                  <v-divider horisontal />
                                  <v-spacer />
                                  <v-btn
                                    small
                                    :disabled="newClientAlias.length < 1"
                                    class="ma-0 ml-0 mr-1 plus-button"
                                    @click="saveNewClientAlias(slotProps.items)"
                                  >
                                    <v-icon>add</v-icon>
                                  </v-btn>
                                </v-layout>
                              </template>
                            </app-tiny-reference>
                          </v-flex>
                          <v-flex xs6>
                            <app-reference
                              v-model="entity.Factory"
                              :outline="true"
                              :height-field="44"
                              class="ma-2"
                              label="Продавец*"
                              :rules="[v => !!v || '']"
                              resource="factories"
                              component-name="Factory"
                              parent-filter="countryId"
                              :parent-id="
                                entity.SendingCountry
                                  ? entity.SendingCountry.id
                                  : 0
                              "
                              :without-parent-lock="true"
                            />
                          </v-flex>
                        </v-layout>
                        <v-layout>
                          <v-flex>
                            <app-reference
                              v-model="entity.Region"
                              :outline="true"
                              :height-field="44"
                              class="ma-2"
                              label="Регион*"
                              :rules="[v => !!v || '']"
                              :disabled="!entity.SendingCountry"
                              resource="regions"
                              component-name="Region"
                              :parent-id="
                                entity.SendingCountry
                                  ? entity.SendingCountry.id
                                  : 0
                              "
                              parent-filter="countryId"
                            />
                          </v-flex>
                          <v-flex>
                            <app-reference
                              v-model="entity.LoadingAddress"
                              :outline="true"
                              :height-field="44"
                              class="ma-2"
                              label="Адрес погрузки*"
                              :rules="[v => !!v || '']"
                              :disabled="!entity.Region"
                              resource="addresses"
                              component-name="Address"
                              :parent-id="entity.Region ? entity.Region.id : 0"
                              parent-filter="regionId"
                            />
                          </v-flex>
                        </v-layout>
                      </v-layout>
                    </v-stepper-content>

                    <v-stepper-content
                      step="3"
                      class="pa-0"
                    >
                      <h2 class="mx-2 stepper-title">
                        Характеристики товара
                      </h2>
                      <v-layout column>
                        <v-layout>
                          <v-flex xs6>
                            <app-reference
                              v-model="entity.ProductCategory"
                              :outline="true"
                              :height-field="44"
                              class="ma-2"
                              label="Категория товара*"
                              resource="product-categories"
                              component-name="ProductCategory"
                              :rules="[v => !!v || '']"
                            />
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field
                              v-model="entity.GeneralProductDescription"
                              outline
                              height="44"
                              class="ma-2"
                              label="Общее описание товара*"
                              :rules="[v => !!v || '']"
                              hide-details
                            />
                          </v-flex>
                        </v-layout>
                        <v-layout>
                          <v-flex xs6>
                            <v-text-field
                              v-model="entity.ProductMaterial"
                              outline
                              height="44"
                              class="ma-2"
                              label="Материал товара*"
                              :rules="[v => !!v || '']"
                              hide-details
                            />
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field
                              v-model="entity.UsingSphere"
                              outline
                              height="44"
                              class="ma-2"
                              label="Сфера применения*"
                              :rules="[v => !!v || '']"
                              hide-details
                            />
                          </v-flex>
                        </v-layout>
                        <v-flex>
                          <v-text-field
                            v-model="entity.ProductSite"
                            outline
                            height="44"
                            class="ma-2"
                            label="Сайт товара*"
                            :rules="[
                              productSiteRules.empty,
                              productSiteRules.valid
                            ]"
                            hide-details
                          />
                        </v-flex>
                        <v-layout>
                          <v-flex xs6>
                            <app-date-picker
                              v-model="entity.ReadyDate"
                              :outline="true"
                              :height-field="44"
                              class="ma-2"
                              label="Дата готовности к отгрузке*"
                            />
                          </v-flex>
                          <v-flex xs6>
                            <app-date-picker
                              v-model="entity.WantedDate"
                              :outline="true"
                              :height-field="44"
                              class="ma-2"
                              label="Желаемая дата доставки к месту выгрузки*"
                            />
                          </v-flex>
                        </v-layout>
                        <v-layout>
                          <v-flex>
                            <DecimalEditor
                              v-model="entity.Brutto"
                              class="ma-2"
                              label="Вес брутто, кг*"
                              :scale="3"
                              :rules="[v => !!v || '']"
                              :outline="true"
                              :height-field="44"
                            />
                          </v-flex>
                          <v-flex>
                            <DecimalEditor
                              v-model="entity.Volume"
                              class="ma-2"
                              label="Объем, м3*"
                              :scale="3"
                              :rules="[v => !!v || '']"
                              :outline="true"
                              :height-field="44"
                            />
                          </v-flex>
                          <v-flex>
                            <DecimalEditor
                              v-model="entity.InvoiceSum"
                              class="ma-2"
                              label="Сумма инвойса*"
                              :scale="2"
                              :rules="[v => !!v || '']"
                              :outline="true"
                              :height-field="44"
                            />
                          </v-flex>
                          <v-flex>
                            <app-reference
                              v-model="entity.Currency"
                              :outline="true"
                              :height-field="44"
                              class="ma-2"
                              label="Валюта*"
                              :rules="[v => !!v || '']"
                              resource="currencies"
                              component-name="Currency"
                            />
                          </v-flex>
                        </v-layout>
                        <v-layout align-center>
                          <v-flex xs4>
                            <EnumSelect
                              v-model="entity.NeedEx"
                              :outline="true"
                              :height-field="44"
                              class="ma-2"
                              :without-selected="false"
                              :return-object="true"
                              label="Нужна ли Ex*"
                              resource="need-ex-types"
                              @change="handleEntityChange"
                            />
                          </v-flex>
                          <v-flex xs3>
                            <LabelSelectSimple
                              v-model="entity.IsPayed"
                              class="mx-2"
                              title="Груз оплачен"
                              @change="handleEntityChange"
                            />
                          </v-flex>
                          <v-flex xs3>
                            <LabelSelectComplex
                              v-model="entity.Urgency"
                              class="mx-2"
                              title="Срочность"
                              :items="[
                                { id: 0, title: 'Стандартная' },
                                { id: 1, title: 'Срочная' }
                              ]"
                              :colors="['green', 'red']"
                              @change="handleEntityChange"
                            />
                          </v-flex>
                          <v-flex xs3>
                            <v-tooltip top>
                              <template slot="activator">
                                <LabelSelectSimple
                                  v-model="entity.Oversized"
                                  class="mx-2"
                                  title="Негабарит"
                                  true-color="red"
                                  false-color="green"
                                  :readonly="true"
                                  @change="handleEntityChange"
                                />
                              </template>
                              <span>Сторона больше 2,4 м</span>
                            </v-tooltip>
                          </v-flex>
                        </v-layout>
                        <v-layout>
                          <v-flex>
                            <Packages
                              v-model="entity.Packages"
                              :is-shipping="true"
                              @change="changePackages"
                            />
                          </v-flex>
                        </v-layout>
                        <v-flex>
                          <v-textarea
                            v-model="entity.CargoComment"
                            outline
                            class="ma-2"
                            label="Комментарии к размерам и кол-ву грузовых мест*"
                            :rules="[v => !!v || '']"
                            hide-details
                            rows="1"
                            auto-grow
                          />
                        </v-flex>
                      </v-layout>
                    </v-stepper-content>

                    <v-stepper-content
                      step="4"
                      class="pa-0"
                    >
                      <h2 class="mx-2 stepper-title">
                        Адрес доставки товара
                      </h2>
                      <v-layout column>
                        <v-layout>
                          <v-flex xs6>
                            <EnumSelect
                              v-model="entity.ShippingType"
                              :outline="true"
                              :height-field="44"
                              label="Тип поставки*"
                              :return-object="true"
                              :rules="[v => !!v || '']"
                              resource="delivery-types"
                              class="ma-2"
                              @input="shippingTypeChanged"
                            />
                          </v-flex>
                          <v-flex xs6>
                            <app-reference
                              v-model="entity.DestinationCountry"
                              :outline="true"
                              :height-field="44"
                              class="ma-2"
                              label="Страна получателя по докам фабрики/отправителя*"
                              :rules="[v => !!v || '']"
                              resource="countries"
                              component-name="Country"
                            />
                          </v-flex>
                        </v-layout>
                        <v-layout>
                          <v-flex xs6>
                            <CountryFilteringReference
                              v-model="entity.UnloadingCountry"
                              :rules="[v => !!v || '']"
                              :height-field="44"
                              :outline="true"
                              :disabled="countryFilteringReferenceDisabled"
                              :without-ukraine="countryWithoutUkraine"
                              :clearable="true"
                              label="Страна выгрузки*"
                              resource="countries"
                              component-name="Country"
                              class="ma-2"
                              @input="unloadingCountryChanged"
                            />
                          </v-flex>
                          <v-flex xs6>
                            <app-reference
                              v-model="entity.UnloadingCity"
                              :outline="true"
                              :height-field="44"
                              class="ma-2"
                              label="Город выгрузки*"
                              :rules="[v => !!v || '']"
                              resource="cities"
                              component-name="City"
                              :disabled="!entity.UnloadingCountry"
                              :parent-id="
                                entity.UnloadingCountry
                                  ? entity.UnloadingCountry.id
                                  : 0
                              "
                              parent-filter="countryId"
                              @input="entity.UnloadingAddress = ''"
                            />
                          </v-flex>
                        </v-layout>
                        <v-flex>
                          <app-reference
                            v-model="entity.UnloadingAddress"
                            :outline="true"
                            :height-field="44"
                            class="ma-2"
                            label="Адрес выгрузки*"
                            :rules="[v => !!v || '']"
                            resource="addresses"
                            component-name="Address"
                            :disabled="!entity.UnloadingCity"
                            :parent-id="
                              entity.UnloadingCity ? entity.UnloadingCity.id : 0
                            "
                            parent-filter="cityId"
                          />
                        </v-flex>
                      </v-layout>
                    </v-stepper-content>
                    <v-stepper-content
                      step="5"
                      class="pa-0"
                    >
                      <v-layout>
                        <SummaryRequest
                          :entity="entity"
                          @change="changeStep"
                        />
                      </v-layout>
                    </v-stepper-content>
                  </v-stepper-items>
                </v-stepper>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn
                small
                class="ma-2"
                color="primary"
                :disabled="!(isValid && isChanged)"
                @click="submit"
              >
                Сохранить
              </v-btn>
              <v-btn
                small
                class="my-0 mx-2"
                @click="submitDraft()"
              >
                Сохранить черновик
              </v-btn>
              <v-btn
                v-if="isDraft && id && id > 0"
                small
                class="my-0 mx-2"
                color="error"
                @click="deleteDraft()"
              >
                Удалить безвозвратно
              </v-btn>
              <v-spacer />
              <v-btn
                small
                class="ma-2"
                @click="cancel"
              >
                Отмена
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex
          xs1
          class="text-xs-center"
        >
          <v-btn
            flat
            large
            icon
            @click="stepper = nextStep"
          >
            <v-icon
              x-large
              color="primary"
            >
              keyboard_arrow_right
            </v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import mixin from "../../mixins/confirm-cancel-changes.js";
import SummaryRequest from "./SummaryRequest.vue";
import LabelSelectSimple from "../../components/label/LabelSelectSimple.vue";
import LabelSelectComplex from "../../components/label/LabelSelectComplex.vue";
import CountryFilteringReference from "../../views/countries/CountryFilteringReference.vue";
import auth from "../../auth";
import * as shipmentRequestsApi from "../../backend/shipmentRequestsApi.js";
import { getUkraine } from "../../backend/countriesApi.js";
import { shippingTypes } from "../shippings/shipping-types.js";
import * as clientsApi from "../../backend/clientsApi.js";
import Packages from "../shippings/components/new-shipping/Packages.vue";

export default {
  components: {
    SummaryRequest,
    LabelSelectSimple,
    LabelSelectComplex,
    CountryFilteringReference,
    Packages,
  },
  mixins: [mixin],
  props: ["id", "isDraft"],
  data() {
    return {
      stepper: 0,
      stepTitles: [
        "Основные",
        "Местонахождение",
        "Характеристики",
        "Доставка",
        "Итог",
      ],
      entityLoaded: false,
      isClient: false,
      isValid: false,
      entity: null,
      originEntity: null,
      isChanged: false,
      newClientAlias: "",
      ukraine: null,
      productSiteValidationExpression: /[-a-zA-Z0-9@:%_+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_+.~#?&//=]*)?/gi,
      productSiteRules: {
        empty: v => !!v || "",
        valid: v => {
          return this.productSiteValidationExpression.test(v) || "";
        },
      },
    };
  },
  computed: {
    pageLoaded() {
      return this.entityLoaded;
    },
    nextStep() {
      if (this.stepper == 1) {
        return 2;
      } else if (this.stepper == this.stepTitles.length) {
        return 1;
      } else {
        return this.stepper + 1;
      }
    },
    prevStep() {
      if (this.stepper == 1) {
        return 5;
      } else {
        return this.stepper - 1;
      }
    },
    blockHeight() {
      return window.innerHeight - 243;
    },
    countryWithoutUkraine() {
      return (
        this.entity.ShippingType &&
        (this.entity.ShippingType.id === shippingTypes.ExportUkraine ||
          this.entity.ShippingType.id === shippingTypes.OutsideUkraine)
      );
    },
    shippingTypes() {
      return shippingTypes;
    },
    countryFilteringReferenceDisabled() {
      return (
        this.entity.ShippingType?.id === shippingTypes.ImportUkraine ||
        (this.entity.ShippingType?.id === shippingTypes.InsideUkraine &&
          this.entity.UnloadingCountry !== null)
      );
    },
  },
  created() {
    this.isClient = auth.getUser().isClient;

    if (this.id && this.id > 0) {
      this.getDraft();
    } else {
      this.getData();
    }
  },
  methods: {
    async getData() {
      try {
        const res = await shipmentRequestsApi.getNewRequest();
        const newEntity = {
          SelfDelivery: 0,
        };
        for (var key in res.data) {
          if (key === "ReadyDate" || key === "WantedDate") {
            newEntity[key] = null;
          } else if (key === "Packages") {
            newEntity[key] =
              res.data[key] && res.data[key].length
                ? res.data[key].map(p => {
                  return {
                    id: p.Id,
                    packageType: {
                      id: p.PackageType.Id,
                      title: p.PackageType.Title,
                    },
                    quantity: p.Quantity,
                    length: p.Length,
                    width: p.Width,
                    height: p.Height,
                  };
                })
                : [];
          } else if (typeof res.data[key] === "object") {
            newEntity[key] = res.data[key]
              ? { id: res.data[key].Id, title: res.data[key].Title }
              : res.data[key];
          } else {
            newEntity[key] = res.data[key];
          }
        }

        this.entity = newEntity;
        this.originEntity = JSON.parse(JSON.stringify(this.entity));
        this.ukraine = await getUkraine();
        this.entityLoaded = true;
      } catch (error) {
        this.showError(error.message);
        this.$router.go(-1);
      }
    },
    async getDraft() {
      const res = await shipmentRequestsApi.getRequestDraft(this.id);
      const newEntity = {};
      for (var key in res.data) {
        if (key === "ReadyDate") {
          newEntity[key] = res.data[key];
        } else if (key === "Packages") {
          newEntity[key] =
            res.data[key] && res.data[key].length
              ? res.data[key].map(p => {
                return {
                  id: p.Id,
                  packageType: {
                    id: p.PackageType.Id,
                    title: p.PackageType.Title,
                  },
                  quantity: p.Quantity,
                  length: p.Length,
                  width: p.Width,
                  height: p.Height,
                };
              })
              : [];
        } else if (typeof res.data[key] === "object") {
          newEntity[key] = res.data[key]
            ? { id: res.data[key].Id, title: res.data[key].Title }
            : res.data[key];
        } else {
          newEntity[key] = res.data[key];
        }
      }

      this.entity = newEntity;
      this.originEntity = JSON.parse(JSON.stringify(this.entity));
      this.entityLoaded = true;
    },
    handleEntityChange() {
      this.isChanged = isEntityReallyChanged(this.originEntity, this.entity);
      function isEntityReallyChanged(origin, current) {
        if (!origin) {
          return true;
        } else {
          let isChanged = false;
          for (const property in origin) {
            if (typeof current[property] === "object") {
              isChanged =
                current[property] && origin[property]
                  ? origin[property].id !== current[property].id
                  : true;
            } else {
              isChanged =
                origin[property].toString() !== current[property].toString();
            }
            if (isChanged) {
              return true;
            }
          }
        }
        return false;
      }
    },
    async submit() {
      const entityForSaving = {
        clientId: this.entity.Client.id,
        employeeId: this.entity.Employee.id,
        sendingCountryId: this.entity.SendingCountry.id,
        factoryId: this.entity.Factory.id,
        manufacturerId: this.entity.Manufacturer.id,
        regionId: this.entity.Region.id,
        loadingAddressId: this.entity.LoadingAddress.id,
        productCategoryId: this.entity.ProductCategory.id,
        generalProductDescription: this.entity.GeneralProductDescription,
        productMaterial: this.entity.ProductMaterial,
        usingSphere: this.entity.UsingSphere,
        productSite: this.entity.ProductSite,
        readyDate: this.entity.ReadyDate || null,
        wantedDate: this.entity.WantedDate || null,
        brutto: this.entity.Brutto,
        volume: this.entity.Volume,
        invoiceSum: this.entity.InvoiceSum,
        currencyId: this.entity.Currency.id,
        needExId: this.entity.NeedEx.id,
        packages:
          this.entity.Packages && this.entity.Packages.length
            ? this.entity.Packages.map(p => {
              return {
                packageTypeId: p.packageType.id,
                quantity: p.quantity,
                length: p.length,
                width: p.width,
                height: p.height,
              };
            })
            : [],
        cargoComment: this.entity.CargoComment,
        shippingTypeId: this.entity.ShippingType.id,
        destinationCountryId: this.entity.DestinationCountry.id,
        unloadingCountryId: this.entity.UnloadingCountry.id,
        unloadingCityId: this.entity.UnloadingCity.id,
        unloadingAddressId: this.entity.UnloadingAddress.id,
        clientAlias: this.entity.ClientAlias,
        urgency: this.entity.Urgency,
        isPayed: this.entity.IsPayed,
        oversized: this.entity.Oversized,
        packingMethod: this.entity.PackingMethod,
      };
      await shipmentRequestsApi.createNewRequest(entityForSaving);
      this.isChanged = false;
      this.showInfo("Запрос добавлен");
      this.$router.go(-1);
      if (this.id && this.id > 0) {
        await shipmentRequestsApi.deleteDraft(this.id);
      }
    },
    async submitDraft() {
      const entityForSaving = {
        clientId: this.entity.Client ? this.entity.Client.id : null,
        employeeId: this.entity.Employee ? this.entity.Employee.id : null,
        sendingCountryId: this.entity.SendingCountry
          ? this.entity.SendingCountry.id
          : null,
        factoryId: this.entity.Factory ? this.entity.Factory.id : null,
        manufacturerId: this.entity.Manufacturer
          ? this.entity.Manufacturer.id
          : null,
        regionId: this.entity.Region ? this.entity.Region.id : null,
        loadingAddressId: this.entity.LoadingAddress
          ? this.entity.LoadingAddress.id
          : null,
        productCategoryId: this.entity.ProductCategory
          ? this.entity.ProductCategory.id
          : null,
        generalProductDescription: this.entity.GeneralProductDescription,
        productMaterial: this.entity.ProductMaterial,
        usingSphere: this.entity.UsingSphere,
        productSite: this.entity.ProductSite,
        readyDate: this.entity.ReadyDate || null,
        wantedDate: this.entity.WantedDate || null,
        brutto: this.entity.Brutto,
        volume: this.entity.Volume,
        invoiceSum: this.entity.InvoiceSum,
        currencyId: this.entity.Currency ? this.entity.Currency.id : null,
        needExId: this.entity.NeedEx ? this.entity.NeedEx.id : null,
        packages:
          this.entity.Packages && this.entity.Packages.length
            ? this.entity.Packages.map(p => {
              return {
                packageTypeId: p.packageType.id,
                quantity: p.quantity,
                length: p.length,
                width: p.width,
                height: p.height,
              };
            })
            : [],
        cargoComment: this.entity.CargoComment,
        shippingTypeId: this.entity.ShippingType
          ? this.entity.ShippingType.id
          : null,
        destinationCountryId: this.entity.DestinationCountry
          ? this.entity.DestinationCountry.id
          : null,
        unloadingCountryId: this.entity.UnloadingCountry
          ? this.entity.UnloadingCountry.id
          : null,
        unloadingCityId: this.entity.UnloadingCity
          ? this.entity.UnloadingCity.id
          : null,
        unloadingAddressId: this.entity.UnloadingAddress
          ? this.entity.UnloadingAddress.id
          : null,
        clientAlias: this.entity.ClientAlias,
        urgency: this.entity.Urgency,
        isPayed: this.entity.IsPayed,
        oversized: this.entity.Oversized,
        packingMethod: this.entity.PackingMethod,
      };

      if (this.id) {
        await shipmentRequestsApi.updateNewDraft(this.id, entityForSaving);
        this.isChanged = false;
        this.showInfo("Черновик сохранен");
        this.$router.push({ name: "shipment-request-drafts" });
      } else {
        await shipmentRequestsApi.createNewDraft(entityForSaving);
        this.isChanged = false;
        this.showInfo("Черновик сохранен");
        this.$router.push({ name: "shipment-request-drafts" });
      }
    },
    async deleteDraft() {
      if (
        confirm(
          "Восстановление черновика невозможно. Вы действительно хотите удалить черновик?",
        )
      ) {
        await shipmentRequestsApi.deleteDraft(this.id);
        this.showInfo("Черновик запроса удален");
        this.$router.go(-1);
      }
    },
    sendingCountryChanged() {
      if (this.entity.Region && this.entity.LoadingAddress) {
        this.entity.Region = null;
        this.entity.LoadingAddress = null;
      }
    },
    unloadingCountryChanged() {
      this.entity.UnloadingCity = null;
      this.entity.UnloadingAddress = null;
    },
    cancel() {
      this.$router.go(-1);
    },
    changeStep(val) {
      this.stepper = val;
    },
    async saveNewClientAlias(items) {
      await shipmentRequestsApi.saveNewClientAlias(
        this.entity.Client.id,
        this.newClientAlias,
      );
      this.entity.ClientAlias = this.newClientAlias;
      items.push({ value: this.newClientAlias, text: this.newClientAlias });
      this.$refs["client-alias"].$children[0].blur();
      this.newClientAlias = "";
    },
    shippingTypeChanged() {
      this.handleEntityChange();

      if (
        this.entity.ShippingType &&
        (this.entity.ShippingType.id === shippingTypes.ImportUkraine ||
          this.entity.ShippingType.id === shippingTypes.InsideUkraine)
      ) {
        this.$set(this.entity, "UnloadingCountry", {
          id: this.ukraine.Id,
          title: this.ukraine.Title,
        });
      }

      if (
        this.countryWithoutUkraine &&
        this.entity.UnloadingCountry &&
        this.entity.UnloadingCountry.id === this.ukraine.Id
      ) {
        this.$set(this.entity, "UnloadingCountry", null);
      }
    },
    async clientChanged() {
      if (!this.entity.Client) {
        this.entity.Employee = null;
        this.entity.ClientAlias = null;
        return;
      }
      this.clientLoading = true;
      const manager = await clientsApi.getClientManager(this.entity.Client.id);
      this.entity.Employee = manager;
      this.clientLoading = false;
    },
    async employeeChanged(value) {
      if (!value) {
        return;
      }
      await clientsApi.assignClientManager(this.entity.Client.id, value.id);
      this.showInfo(`Менеджер клиента ${this.entity.Client.title} изменен`);
    },
    changePackages(value) {
      this.entity.Packages = value;
      if (
        this.entity.Packages.find(
          i => i.width > 2.4 || i.height > 2.4 || i.length > 2.4,
        )
      ) {
        this.entity.Oversized = true;
      } else {
        this.entity.Oversized = false;
      }
      this.handleEntityChange();
    },
  },
};
</script>
